// @ts-ignore
import { Slider } from 'antd'
import '../main.css'
import {LayoutView} from '../../../../../state/atom'
import {useRecoilState} from 'recoil'

export default function SliderComponent() {
  const [LayoutViewNumber, setLayoutView] = useRecoilState(LayoutView);

  function onChange(value: any) {
    setLayoutView(`cropper${value}`)
  }

  return (
    <div className={'slide'}>
      <Slider defaultValue={1} min={1} max={3} onChange={onChange}/>
    </div>
  )
}
